import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { ROUTES, PAGINAS, FUNCIONALIDADES } from '../../../routes';
import { getTipoImovel, cadastrarTipoImovel, alterarTipoImovel, excluirTipoImovel } from './tipos_imoveis_service';
import { CadastroBasicoNomeSituacaoForm } from '../../../components/CadastroBasicoNomeSituacaoForm';
export var TiposImoveisAlterar = function () {
    var services = {
        getItem: getTipoImovel,
        cadastrarItem: cadastrarTipoImovel,
        alterarItem: alterarTipoImovel,
        excluirItem: excluirTipoImovel,
    };
    return _jsx(CadastroBasicoNomeSituacaoForm, { pagina: PAGINAS.TIPOS_IMOVEIS, paginaPermissao: FUNCIONALIDADES.TIPOS_IMOVEIS, rota: ROUTES.TIPOS_IMOVEIS, services: services });
};
export default TiposImoveisAlterar;
